import { BECAUSE_YOU_SHOPPED_VIEW } from 'core/modules/ForYou/actions/types';

export const triggerBecauseYouShoppedIsViewed = data => ({
  type: BECAUSE_YOU_SHOPPED_VIEW,
  data,
});
